<template>
  <Col :xs="6" :sm="6" :md="4" :lg="3">
    <div class="room-card" :class="{ 'ordered': isActive, 'can-order': !isActive }">
      <div>
        <span class="room-no">{{ stock.stockNumber }}</span>
        <span class="room-day">{{ stock.stockVacancyDay }}天</span>
      </div>
      <div style="text-align: center">¥ {{ stock.stockRentPrice }}</div>
    </div>
  </Col>
</template>
<script>
  export default {
    name: "roomCard",
    props: {
      stock: Object
    },
    data() {
      return {
      }
    },
    computed: {
      isActive () {
        return this.stock.stockIsOrder === 2
      }
    }
  }
</script>
<style scoped lang="less">
  .room-card {
    border-radius: 6px;
    margin: 0.3rem;
    padding: 0.1rem;
  }

  .ordered {
    border: 1px solid #91d5ff;
    background-color: #e6f7ff;
  }

  .can-order {
    background-color: #f8f8f9;
    border: 1px solid #e9eaec;
  }

  .room-no {
    float: left;
    width: 50%;
    text-align: center;
    font-weight: bolder;
    color: #000000;
  }

  .room-day {
    float: right;
    width: 50%;
    text-align: center
  }
</style>
